export default __webpack_public_path__ + "d4da4e79260c7720c6146a626ebd983e.png";